const styledDialogueSX = {
    backgroundColor: "background.dialogue",
};

export const styledDialogChildSX = {
    paddingX: 2,
};

export default styledDialogueSX;
